<script lang="ts" setup>
  import { CartLayout, CartWithSummaryLayout } from '@storefront/components';

  defineOptions({
    layout: [CartLayout, CartWithSummaryLayout],
    inheritAttrs: false,
  });
</script>
<template>
  <FormController v-slot="{ processing, submit }" :action="$route('web.cart.purchase.store')" method="POST">
    <div class="warning">
      <p class="warning-title">{{ $t('SHOP.CART.HEADER.CHECK_ORDER_DATA') }}</p>
      <p class="warning-content">{{ $t('SHOP.CART.MESSAGE.CHECK_ORDER_DATA') }}</p>
    </div>

    <div class="authorize-form">
      <div class="authorize-heading">
        <h2 class="authorize-heading">{{ $t('SHOP.CART.HEADER.BLIK_AUTHORIZATION') }}</h2>
        <p class="authorize-description">{{ $t('SHOP.CART.MESSAGE.BLIK_AUTHORIZATION') }}</p>
      </div>
      <div class="authorize-input-wrapper">
        <SfFormInput :label="$t('SHOP.CART.LABEL.BLIK_AUTHORIZATION_CODE')" inputmode="numeric" name="authorizationCode" required type="text" />
      </div>
    </div>

    <UiButtonGroup>
      <SfButton :loading="processing" large primary @click="submit">
        <template #before>
          <SfIconWallet aria-hidden="true" />
        </template>
        <template #default>
          {{ $t('SHOP.CART.ACTION.ORDER_AND_PAY') }}
        </template>
      </SfButton>
    </UiButtonGroup>
  </FormController>

  <RouterView />
</template>
<style lang="scss" scoped>
  .warning {
    font-size: 0.875rem;
    color: var(--secondary-color);

    .warning-title {
      font-size: 0.875rem;
      font-weight: var(--font-weight-bold);
      color: var(--color-default);
    }

    .warning-content {
      font-size: 0.875rem;
    }
  }

  .authorize-form {
    background-color: var(--secondary-background);
    border-radius: var(--border-radius);
    display: flex;
    flex-direction: column;
    padding: 2rem;
    gap: 2rem;

    .authorize-heading {
      font-size: 1rem;
    }

    .authorize-description {
      color: var(--secondary-color);
      font-size: 0.875rem;
    }

    .authorize-input-wrapper {
      max-width: 180px;
    }
  }
</style>
